export default __webpack_public_path__ + "static/mobility-card-592b7da78042d5af1a01f4e75875a384.png";